import type { InboxTagDto } from "../../../api/inbox-tags";

import type {
  InboxV2Board,
  InboxV2Feed,
  InboxV2Tag,
  InboxV2TagAccess,
} from "../../types";

export function mapInboxV2BoardDtoToBoard(board: {
  id: string;
  name: string;
  access: InboxV2Board["access"];
  createdByUserId?: string;
  pinned?: boolean;
  feedIds: string[];
}): InboxV2Board {
  return {
    id: board.id,
    name: board.name,
    access: board.access,
    createdByUserId: board.createdByUserId,
    pinned: Boolean(board.pinned),
    feedIds: board.feedIds,
  };
}

export function mapInboxV2FeedDtoToFeed(feed: {
  id: string;
  boardId: string;
  name: string;
  access: InboxV2Feed["access"];
  createdByUserId?: string;
  hidden: boolean;
  filters: {
    accountIds: InboxV2Feed["filters"]["accountIds"];
    conversationIds?: InboxV2Feed["filters"]["conversationIds"];
    messageType: InboxV2Feed["filters"]["messageType"];
    status: InboxV2Feed["filters"]["status"];
    postType: InboxV2Feed["filters"]["postType"];
    sentiment: InboxV2Feed["filters"]["sentiment"];
    assignee?: InboxV2Feed["filters"]["assignee"];
    tags?: InboxV2Feed["filters"]["tags"];
    mentioned?: InboxV2Feed["filters"]["mentioned"];
    dateRange?: InboxV2Feed["filters"]["dateRange"];
    messageMatch?: InboxV2Feed["filters"]["messageMatch"];
    saved?: InboxV2Feed["filters"]["saved"];
  };
}): InboxV2Feed {
  return {
    id: feed.id,
    boardId: feed.boardId,
    name: feed.name,
    access: feed.access,
    createdByUserId: feed.createdByUserId,
    hidden: feed.hidden,
    filters: {
      accountIds: feed.filters.accountIds,
      conversationIds: feed.filters.conversationIds ?? { match: "all" },
      messageType: feed.filters.messageType,
      status: feed.filters.status,
      postType: feed.filters.postType,
      sentiment: feed.filters.sentiment,
      assignee: feed.filters.assignee ?? { match: "all" },
      tags: feed.filters.tags ?? { match: "all" },
      mentioned: feed.filters.mentioned ?? { match: "all" },
      dateRange: feed.filters.dateRange ?? { dateFrom: null, dateTo: null },
      messageMatch: feed.filters.messageMatch,
      saved: feed.filters.saved ?? { match: "all" },
    },
    conversationIds: [],
  };
}

export function mapTagToInboxV2Tag(tag: InboxTagDto): InboxV2Tag {
  return {
    access: normalizeInboxV2TagAccess(tag.access),
    id: tag.id,
    label: tag.label,
    color: tag.color,
    archived: tag.archived,
    archivedAt: tag.archivedAt,
    hidden: tag.hidden,
  };
}

function normalizeInboxV2TagAccess(
  access: InboxTagDto["access"] | undefined
): InboxV2TagAccess {
  if (access?.scope === "board" && access.boardId) {
    return {
      boardId: access.boardId,
      scope: "board",
    };
  }

  return { scope: "organizational" };
}
